import Vue from 'vue'
import VueNativeSock from '@/plugins/vue-native-websocket'
import store from '@/store'
import backoff from '@/libs/backoff'

// used by vue-native-websocket, es6 only, so polyfill
import 'string.prototype.startswith'

let socket = null
let waitForUUID = false

const actions = {
  subscribe: 'subscribe',
  unsubscribe: 'unsubscribe',
  add: 'add',
  delete: 'delete',
  update: 'update',
  log: 'log',
  view: 'view',
  recommendation: 'recommendation',
  share: 'share'
}

const retryDelay = 3000
const connectRetryDelay = 250
const waitForUUIDDelay = 500

const wsRoot = process.env.WS_ROOT

const lib = {
  connect: function () {
    if (store) {
      backoff.exponential(connectRetryDelay, () => {
        VueNativeSock.install(Vue, wsRoot, { store, format: 'json' })
        socket = Vue.prototype.$socket
      })
    } else {
      setTimeout(() => { this.connect() }, connectRetryDelay)
    }
  },
  isOpen: function () {
    return store.getters.isSocketConnected
  },
  send: function (action, type, id, childType, childTypeID, subType, subTypeID) {
    if (this.isOpen() && !waitForUUID) {
      let uuid = ''
      if (store.getters.hasCurrentUser) {
        uuid = store.getters.currentUser.uuid
      } else if (store.getters.socketUUID) {
        uuid = store.getters.socketUUID
      } else {
        waitForUUID = true
        setTimeout(() => { waitForUUID = false }, waitForUUIDDelay)
      }

      if (action === 'subscribe' && this.isSubscribed(type, id, childType)) {
        return
      }

      if (action === 'subscribe' || action === 'unsubscribe') {
        store.dispatch(action, { type, id, childType })
      }

      return socket.sendObj({ action, type, id, childType, uuid, childTypeID, subType, subTypeID })
    }

    setTimeout(() => {
      this.send(action, type, id, childType)
    }, waitForUUID ? waitForUUIDDelay : retryDelay)
  },
  subscribe: function (type, id, childType) {
    return this.send(actions.subscribe, type, id, childType)
  },
  subscribeAll: function (type, childType) {
    return this.subscribe(type, 0, childType)
  },
  unsubscribe: function (type, id, childType) {
    return this.send(actions.unsubscribe, type, id, childType)
  },
  unsubscribeAll: function (type, childType) {
    return this.unsubscribe(type, 0, childType)
  },
  add: function (type, id, childType, childTypeID, subType, subTypeID) {
    return this.send(actions.add, type, id, childType, childTypeID, subType, subTypeID)
  },
  delete: function (type, id, childType, childTypeID, subType, subTypeID) {
    return this.send(actions.delete, type, id, childType, childTypeID, subType, subTypeID)
  },
  update: function (type, id, childType, childTypeID, subType, subTypeID) {
    return this.send(actions.update, type, id, childType, childTypeID, subType, subTypeID)
  },
  connected: function () {
    backoff.reset()
    this.resubscribe()
  },
  resubscribe: function () {
    store.dispatch('resubscribe')
  },
  log: function (from, to) {
    return this.send(actions.log, to, 0, from)
  },
  isSubscribed: function (type, id, childType) {
    return store.getters.isSubscribed({ type, id, childType })
  },
  view: function (type, id, childType) {
    return this.send(actions.view, type, id, childType)
  },
  recommendation: function (type, from, to) {
    this.send(actions.recommendation, type, from, '', to)
  },
  share: function (type, id, childType) {
    this.send(actions.share, type, id, childType)
  }
}

lib.connect()

export default lib
